<script>
import { MapAgentStationStatus, MapRefundStatus } from "@/common/util";
import basicLineChart from "@/components/visionStatistics/basicLineChart.vue";
import basicBarChart from "@/components/visionStatistics/basicBarChart.vue";

import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
const mapTabName = {
  agent: "新增代理商",
  sales: "终端销量",
  stock: "代理商库存",
  courseBuy: "代理商进货",
  courseRefund: "代理商退货",
  station: "新增医疗机构",
  lively: "活跃医疗机构"
};
export default {
  components: {
    basicLineChart,
    basicBarChart
  },
  data() {
    const defaultDate = [
      moment()
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    const roles =
      localStorage.getItem("roles").indexOf("ROLE_SUPER_ADMIN") > -1
        ? "superAdmin"
        : "regionManager";
    return {
      roles,
      dateRange: defaultDate,
      dateRangeStock: [
        moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ],
      chartArray: [],
      RefreshChart1: true,
      RefreshChart2: true,
      RefreshChart3: true,
      ProvinceList: [],
      provinceCity: undefined,
      achievementData: {
        remainingTreatmentCount: undefined,
        sales: undefined,
        targetCount: undefined
      },
      options: [
        {
          value: "YEAR",
          label: "年度"
        },
        {
          value: "QUARTER",
          label: "季度"
        },
        {
          value: "MONTH",
          label: "月度"
        }
      ],
      dateRangeValue: "MONTH",
      activeTab: "sales",
      totalSales: {
        StatisticsResult: undefined,
        chartTitle: undefined,
        chartYTitle: undefined,
        yType: undefined,
        seriesNameY: undefined
      },
      dateRangeTotalSales: undefined,
      AgentSalesAndStation: {
        StatisticsResult: undefined,
        chartTitle: undefined,
        chartYTitle: undefined,
        yType: undefined,
        seriesNameY: undefined
      },
      agentList: [],
      agentId: undefined,
      activeAgentName: undefined,
      totalStock: undefined,
      dateRangeTotalStock: undefined
    };
  },
  created() {
    this.loadProvice();
    this.loadAgent();
    this.managerSales();
    this.loadStatistic();
    this.stockStatistic();
  },
  methods: {
    async loadProvice() {
      let ProvinceList = await this.$http.getProvinceList(this.roles);
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            id: o.id,
            name: o.name
          };
        });
        this.ProvinceList = provinceChildren;
      }
    },
    async loadAgent(provinceId) {
      const type = this.roles === "superAdmin" ? "group" : "region";
      const params = {};
      if (provinceId) {
        params.provinceId = provinceId;
      }
      const result = await this.$http.getAgentList(params, type);
      if (result && result.content) {
        this.agentList = result.content.map(o => {
          return {
            value: o.user.id,
            label: o.companyName || o.user.name
          };
        });
      }
    },
    onSearch() {
      if (this.agentId) {
        this.activeAgentName = this.agentId
          ? this.agentList.filter(o => o.value === this.agentId)[0].label
          : undefined;
        this.loadStatistic();
        this.managerSales();
        this.stockStatistic();
      } else {
        this.$message.warning("请选择代理商！");
      }
    },
    async loadStatistic() {
      const params = {};
      const chartType = this.activeTab;
      if (this.agentId) {
        params.agentId = this.agentId;
        if (this.provinceCity) {
          params.provinceId = this.provinceCity;
        }
        if (chartType === "courseBuy" || chartType === "courseRefund") {
          params.operateType = chartType === "courseBuy" ? "PAY" : "REFUND";
        }
        params.statisticType =
          this.dateRangeValue === "YEAR" ? "YEAR" : "MONTH";
        if (this.dateRangeValue !== "YEAR") {
          params.end = moment().format("YYYY-MM-DD");
          params.start = moment()
            .subtract(11, "month")
            .startOf("month")
            .format("YYYY-MM-DD");
        }
        let result = await this.$http.managerRangeStatistic(params, chartType);
        if (this.dateRangeValue === "YEAR") {
          let AgentSalesAndStation = {
            chartTitle: undefined,
            chartYTitle: "个数",
            yType: "AgentSalesAndStation",
            seriesNameY: mapTabName[chartType],
            StatisticsX: [],
            StatisticsY: [],
            legend: []
          };
          if (chartType === "sales") {
            AgentSalesAndStation.legend = ["实际销售", "销售目标"];
          }
          const tempX = [];
          const tempY1 = [];
          const tempY2 = [];
          result.forEach(item => {
            tempX.push(`${moment(item.time).get("year")}年`);
            tempY1.push(item.count);
            tempY2.push(item.targetCount);
          });
          AgentSalesAndStation.StatisticsX.push(tempX);
          AgentSalesAndStation.StatisticsY.push(tempY1);
          if (chartType === "client") {
            AgentSalesAndStation.StatisticsY.push(tempY2);
          }
          this.AgentSalesAndStation = AgentSalesAndStation;
        } else if (this.dateRangeValue === "QUARTER") {
          const AgentSalesAndStation = {
            chartTitle: undefined,
            chartYTitle: "个数",
            yType: "AgentSalesAndStation",
            seriesNameY: mapTabName[chartType],
            StatisticsX: [],
            StatisticsY: [],
            legend: []
          };
          const tempX = [];
          const tempY1 = [];
          const mapQuarter = {};
          result.forEach(item => {
            const tempQuarter = `${moment(item.time).year()}年第${moment(
              item.time
            ).quarter()}季度`;
            if (mapQuarter[tempQuarter]) {
              mapQuarter[tempQuarter] = mapQuarter[tempQuarter] + item.count;
            } else {
              mapQuarter[tempQuarter] = item.count;
            }
          });
          for (let item in mapQuarter) {
            tempX.push(item);
            tempY1.push(mapQuarter[item]);
          }
          AgentSalesAndStation.StatisticsX.push(tempX);
          AgentSalesAndStation.StatisticsY.push(tempY1);
          this.AgentSalesAndStation = AgentSalesAndStation;
        } else {
          const AgentSalesAndStation = {
            chartTitle: undefined,
            chartYTitle: "个数",
            yType: "AgentSalesAndStation",
            seriesNameY: mapTabName[chartType],
            StatisticsX: [],
            StatisticsY: [],
            legend: []
          };
          const tempX = [];
          const tempY1 = [];
          result.forEach(item => {
            tempX.push(`${moment(item.time).get("month") + 1}月`);
            tempY1.push(item.count);
          });
          AgentSalesAndStation.StatisticsX.push(tempX);
          AgentSalesAndStation.StatisticsY.push(tempY1);
          this.AgentSalesAndStation = AgentSalesAndStation;
        }
      } else {
        const AgentSalesAndStation = {
          chartTitle: undefined,
          chartYTitle: "个数",
          yType: "AgentSalesAndStation",
          seriesNameY: mapTabName[chartType],
          StatisticsX: [],
          StatisticsY: [],
          legend: []
        };
        const tempX = [];
        const tempY1 = [];
        AgentSalesAndStation.StatisticsX.push(tempX);
        AgentSalesAndStation.StatisticsY.push(tempY1);
        this.AgentSalesAndStation = AgentSalesAndStation;
      }
      this.RefreshChart1 = false;
      this.$nextTick(() => {
        this.RefreshChart1 = true;
      });
    },
    async managerSales() {
      if (this.agentId) {
        const params = {
          start: this.dateRange[0],
          end: this.dateRange[1]
        };
        if (this.agentId) {
          params.agentId = this.agentId;
        }
        const result = await this.$http.managerSalesStatistic(params);
        const totalSales = {
          chartTitle: undefined,
          chartYTitle: "销量",
          yType: "totalSales",
          seriesNameY: "累计销量",
          StatisticsResult: []
        };
        let total = 0;
        result.forEach(item => {
          total = total + item.count;
          totalSales.StatisticsResult.push({
            createdAt: item.time,
            value: total
          });
        });
        this.dateRangeTotalSales = total;
        this.totalSales = totalSales;
      } else {
        const totalSales = {
          chartTitle: undefined,
          chartYTitle: "销量",
          yType: "totalSales",
          seriesNameY: "累计销量",
          StatisticsResult: []
        };
        let total = 0;
        this.dateRangeTotalSales = total;
        this.totalSales = totalSales;
      }

      this.RefreshChart3 = false;
      this.$nextTick(() => {
        this.RefreshChart3 = true;
      });
    },
    onSwitchTab(tabName) {
      this.activeTab = tabName;
      this.loadStatistic();
    },
    onDateChange() {
      this.managerSales();
    },
    onDateTypeChange() {
      if (this.agentId) {
        this.loadStatistic();
      } else {
        this.$message.warning("请选择代理商！");
      }
    },
    onProvicneChange(value) {
      this.loadAgent(value);
      this.agentId = undefined;
    },
    onClearData(type) {
      if (tyep === "agent") {
        this.managerSales();
        this.loadStatistic();
        this.stockStatistic();
      } else {
        this.loadAgent();
        this.agentId = undefined;
      }
    },
    async stockStatistic() {
      if (this.agentId) {
        const params = {
          start: this.dateRangeStock[0],
          end: this.dateRangeStock[1],
          statisticType: "DAY",
          agentId: this.agentId
        };
        const result = await this.$http.managerRangeStatistic(params, "stock");
        const totalStock = {
          chartTitle: undefined,
          chartYTitle: "库存量",
          yType: "totalStock",
          seriesNameY: "库存量",
          StatisticsResult: []
        };
        let total = 0;
        result.forEach(item => {
          total = total + item.count;
          totalStock.StatisticsResult.push({
            createdAt: item.time,
            value: item.count
          });
        });
        this.dateRangeTotalStock = total;
        this.totalStock = totalStock;
      } else {
        const totalStock = {
          chartTitle: undefined,
          chartYTitle: "库存量",
          yType: "totalStock",
          seriesNameY: "库存量",
          StatisticsResult: []
        };
        let total = 0;
        this.dateRangeTotalStock = total;
        this.totalStock = totalStock;
      }

      this.RefreshChart2 = false;
      this.$nextTick(() => {
        this.RefreshChart2 = true;
      });
    },
    onDateChangeStock() {
      if (this.agentId) {
        this.stockStatistic();
      } else {
        this.$message.warning("请选择代理商！");
      }
    }
  }
};
</script>
<template>
  <div class="StatisticsAgent">
    <div class="cardTitleText">代理商统计图</div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle">省份：</span>
        <span>
          <el-select
            v-model="provinceCity"
            placeholder="请选择"
            class="selectInputStyle"
            @change="onProvicneChange"
            clearable
            filterable
            @clear="onClearData('province')"
          >
            <el-option
              v-for="item in ProvinceList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>
        <span class="searchTitle">代理商：</span>
        <span>
          <el-select
            v-model="agentId"
            placeholder="请选择"
            class="selectInputStyle"
            clearable
            filterable
            @clear="onClearData('agent')"
          >
            <el-option
              v-for="item in agentList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </span>
        <el-button class="searchButton" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="20" class="colStyle">
        <span
          class="filterTab"
          :style="activeTab === 'sales' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('sales')"
        >终端销量</span>
        <span
          class="filterTab"
          :style="activeTab === 'courseBuy' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('courseBuy')"
        >代理商进货</span>
        <span
          class="filterTab"
          :style="activeTab === 'courseRefund' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('courseRefund')"
        >代理商退货</span>
        <span
          class="filterTab"
          :style="activeTab === 'station' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('station')"
        >新增医疗机构</span>
        <span
          class="filterTab"
          :style="activeTab === 'lively' ? { color: '#ffffff', 'background-color': '#00c1de'} : ''"
          @click="onSwitchTab('lively')"
        >活跃医疗机构</span>
      </el-col>
      <el-col :span="4" class="colStyle targetView">
        <div class="selectDateView">
          <el-select
            v-model="dateRangeValue"
            @change="onDateTypeChange"
            class="timeFilterSelect"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <div v-if="activeAgentName" class="dateSelectTitle">当前代理商：{{activeAgentName}}</div>
    <div class="chartview" v-if="RefreshChart1">
      <basicBarChart
        v-if="AgentSalesAndStation.StatisticsX"
        class="statisticsCharts"
        :StatisticsX="AgentSalesAndStation.StatisticsX"
        :StatisticsY="AgentSalesAndStation.StatisticsY"
        :legend="AgentSalesAndStation.legend"
        :chartTitle="AgentSalesAndStation.chartTitle"
        :chartYTitle="AgentSalesAndStation.chartYTitle"
        :yType="AgentSalesAndStation.yType"
        :seriesNameY="AgentSalesAndStation.seriesNameY"
        width="100%"
      />
    </div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <div class="dateSelectTitle">代理商存货 {{activeAgentName}}</div>
        <div>
          <el-date-picker
            v-model="dateRangeStock"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="onDateChangeStock"
          ></el-date-picker>
        </div>
      </el-col>
      <!-- <el-col :span="12" class="colStyle targetView">
        <div class="searchLocation" style="margin-top: 0px">
          <div>
            <div class="saleNumberTitle">本期库存量</div>
            <div class="saleNumber">{{dateRangeTotalStock || '--'}}</div>
          </div>
        </div>
      </el-col> -->
    </el-row>
    <div class="chartview" v-if="RefreshChart2">
      <basicLineChart
        class="statisticsCharts"
        v-if="totalStock.StatisticsResult"
        :StatisticsResult="totalStock.StatisticsResult"
        :chartTitle="totalStock.chartTitle"
        :chartYTitle="totalStock.chartYTitle"
        :yType="totalStock.yType"
        :seriesNameY="totalStock.seriesNameY"
        width="100%"
      />
    </div>
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="12" class="colStyle">
        <div class="dateSelectTitle">{{activeAgentName}} 累计销量</div>
        <div>
          <el-date-picker
            v-model="dateRange"
            size="medium"
            class="dateRange"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="onDateChange"
          ></el-date-picker>
        </div>
      </el-col>
      <el-col :span="12" class="colStyle targetView">
        <div class="searchLocation" style="margin-top: 0px">
          <div>
            <div class="saleNumberTitle">本期销量</div>
            <div class="saleNumber">{{dateRangeTotalSales || '--'}}疗程</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="chartview" v-if="RefreshChart3">
      <basicLineChart
        class="statisticsCharts"
        v-if="totalSales.StatisticsResult"
        :StatisticsResult="totalSales.StatisticsResult"
        :chartTitle="totalSales.chartTitle"
        :chartYTitle="totalSales.chartYTitle"
        :yType="totalSales.yType"
        :seriesNameY="totalSales.seriesNameY"
        width="100%"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.StatisticsAgent {
  padding-left: 30px;
  padding-top: 15px;

  .cardTitleText {
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
    margin: 15px 0;
  }

  .gameSearchForm {
    margin: 0px 0px 25px !important;
    color: rgba(89, 94, 122, 1);

    .colStyle {
      padding: 0 !important;
    }
    .targetView {
      float: right;
    }
    .selectInputStyle {
      width: 200px;
      margin-right: 10px;
    }

    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }
    .dateSelectTitle {
      padding-bottom: 10px;
      color: rgba(10, 10, 10, 1);
      line-height: 20px;
    }
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .filterTab {
      display: inline-block;
      margin-right: 20px;
      font-size: 14px;
      line-height: 20px;
      //   margin-left: -10px;
      padding: 5px 10px;
      border-radius: 4px;
      cursor: pointer;
    }
    .searchButton {
      background-color: #00c1de;
      border-color: #00c1de;
      color: #fff;
      height: 36px;
    }
    .searchLocation {
      float: right;
      display: flex;
      margin-right: 70px;
      margin-top: -20px;
      .line {
        width: 1px;
        height: 40px;
        background-color: #e4e8eb;
        margin-left: 25px;
        margin-right: 25px;
      }
      .saleNumberTitle {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
      }
      .saleNumber {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
      }
    }
    .selectDateView {
      float: right;
      display: flex;
      margin-right: 30px;
      margin-top: -20px;

      .timeFilterSelect {
        width: 100px;
      }
    }
  }

  .chartview {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    min-height: 350px;
    .statisticsCharts {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionStatistics/statisticManagerAgent.vue